import { Info } from 'lucide-react';
import toast, { Renderable, Toast, ValueOrFunction } from 'react-hot-toast';

type Message = ValueOrFunction<Renderable, Toast>;
export const successMessage = (text: Message) => {
  toast.success(text, { duration: 5000 });
};

export const errorMessage = (text: Message) => {
  toast.error(text);
};

export const infoMessage = (text: string) => {
  toast.custom(t => {
    return (
      <div
        key={t.id}
        className={`
          flex items-center gap-3 rounded-2xl border border-blue-400
          bg-blue-50 p-4 shadow-lg transition-all
          ${t.visible ? 'animate-enter' : 'animate-leave'}
        `}
      >
        <Info className="text-blue-500" size={24} />
        <div className="text-sm text-blue-700">{text}</div>
      </div>
    );
  });
};
